// extracted by mini-css-extract-plugin
var _1 = "_dailyGoldPrice-module__block-container";
var _2 = "_dailyGoldPrice-module__buy-price";
var _3 = "_dailyGoldPrice-module__container";
var _4 = "_dailyGoldPrice-module__export-daily-balancing-button";
var _5 = "_dailyGoldPrice-module__gold-price-text";
var _6 = "_dailyGoldPrice-module__info-container";
var _7 = "_dailyGoldPrice-module__price";
var _8 = "_dailyGoldPrice-module__price-container";
var _9 = "_dailyGoldPrice-module__price-label";
var _a = "_dailyGoldPrice-module__sell-price";
var _b = "_dailyGoldPrice-module__title";
export { _1 as "block-container", _2 as "buy-price", _3 as "container", _4 as "export-daily-balancing-button", _5 as "gold-price-text", _6 as "info-container", _7 as "price", _8 as "price-container", _9 as "price-label", _a as "sell-price", _b as "title" }
